import CommuneWebConfigurationProjection from "@/types/projections/CommuneWebConfigurationProjection";
import BIObject from "@/types/taxcard/BIObject";
import { GuestTypesEnum } from "@/types/taxcard/GuestType";
import AdditionalMandatoryField from "@/types/validation/AdditionalMandatoryField";
import moment from "moment";

export function getMandatoryFieldsToValidate(bIObject: BIObject, additionalMandatoryFields: AdditionalMandatoryField[]): string[] {
  let mandatoryFieldsToValidate = [];
  if (bIObject.bIObjectData.guestType == GuestTypesEnum.donation) { //Donation
    mandatoryFieldsToValidate.push(
      'email',
      'donationValue',
      'isAnonymous-false'
    )
  } else if (bIObject.bIObjectData.guestType == GuestTypesEnum.overnight && !bIObject.bIObjectData.isAnnual) { //Overnight
    mandatoryFieldsToValidate.push(
      'isAnonymous-false',
      'salutation',
      'stayBegin',
      'stayEnd',
      'stayEnd-after-stayBegin',
      'stayBegin-notSame-stayEnd',
      'stayBegin-stayEnd-maxYear',
      'accommodation',
      'firstName',
      'lastName',
      'nationality'
    )
    setAdditionalMandatoryFToMFToValidate(bIObject, mandatoryFieldsToValidate, additionalMandatoryFields);
  } else if (bIObject.bIObjectData.guestType == GuestTypesEnum.overnight && bIObject.bIObjectData.isAnnual) {  //Overnight Annual Card
    mandatoryFieldsToValidate.push(
      'isAnonymous-false',
      'salutation',
      'annualCardResidenceType',
      'annualYear',
      'annualCardPhoto',
      'firstName',
      'lastName',
      'nationality'
    )
    setAdditionalMandatoryFToMFToValidate(bIObject, mandatoryFieldsToValidate, additionalMandatoryFields);
  } else if (bIObject.bIObjectData.guestType == GuestTypesEnum.day && bIObject.bIObjectData.isAnonymous) { //Day Annonymous
    mandatoryFieldsToValidate.push(
      'stayBegin',
      'stayEnd',
      'stayEnd-after-stayBegin',
      'stayBegin-stayEnd-maxYear'
    )
    setAdditionalMandatoryFToMFToValidate(bIObject, mandatoryFieldsToValidate, additionalMandatoryFields);
  } else if (bIObject.bIObjectData.guestType == GuestTypesEnum.day && !bIObject.bIObjectData.isAnonymous) { //Day Not Anonymous
    mandatoryFieldsToValidate.push(
      'isAnonymous-false',
      'salutation',
      'stayBegin',
      'stayEnd',
      'stayEnd-after-stayBegin',
      'stayBegin-stayEnd-maxYear',
      'firstName',
      'lastName'
    )
    setAdditionalMandatoryFToMFToValidate(bIObject, mandatoryFieldsToValidate, additionalMandatoryFields);
  }
  return mandatoryFieldsToValidate;
}

function setAdditionalMandatoryFToMFToValidate(bIObject: BIObject, fieldsToValidate: string[], additionalMandatoryFields: AdditionalMandatoryField[]) {
  const isUnder15 = bIObject.bIObjectData.birthday && moment.utc().diff(moment.utc(bIObject.bIObjectData.birthday), 'years') <= 14;
  additionalMandatoryFields.forEach(({ fieldName, guestType, isMandatory, isAnonymous, isOptionalByNationality }) => {
    if (isUnder15 && (fieldName === 'cellphoneNumber' || fieldName === 'email')) {
      return;
    }
    if (
      bIObject.bIObjectData.guestType === guestType &&
      isMandatory &&
      bIObject.bIObjectData.isAnonymous === isAnonymous &&
      (!isOptionalByNationality || bIObject.bIObjectData.nationality != isOptionalByNationality)
    ) {
      fieldsToValidate.push(fieldName);
    }
  });
}

export function getWebConfigValOfElement(fieldOrSection: string, webConfig: CommuneWebConfigurationProjection): any {
  switch (fieldOrSection) {
    case 'guestType':
      if (webConfig) {
        return webConfig.showGuestTypeSelector;
      }
      return true
    case 'isAnonymous':
      if (webConfig) {
        return webConfig.showIsAnonymousSelector;
      }
      return true
    case 'email':
      if (webConfig && webConfig.elements && webConfig.elements.hasOwnProperty('email')) {
        return webConfig.elements['email'];
      }
      return true;
    case 'petCount':
      if (webConfig && webConfig.elements && webConfig.elements.hasOwnProperty('petCount')) {
        return webConfig.elements['petCount'];
      }
      return true;
    case 'childCount':
      if (webConfig && webConfig.elements && webConfig.elements.hasOwnProperty('childCount')) {
        return webConfig.elements['childCount'];
      }
      return false;
    default:
      break;
  }
  return true;
}